<template>
  <v-container style="margin-right: 0px;margin-left: 0px; margin-top: 20px; width: 100%;">
    <v-layout row wrap justify-end style="margin-right:5%">

      <v-btn style="height:50%" class="hidden-xs-only" small @click="LoadGraphic()" color="accent">Visualizar</v-btn>

    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-select name="yearCommercial" v-bind:label="$t('message.yearCommercial')" v-validate="'required'"
          :error-messages="errors.collect('yearCommercial')" item-text="Valor" :items="yearCommercialBudget"
          v-model="e6yearCommercialBudget" @change="getBusinessLine()"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="typeProduction" v-bind:label="$t('message.typeProduction')" v-validate="'required'"
          :error-messages="errors.collect('typeProduction')" :items="catalogTypeOfProductionBudget" item-text="value"
          item-value="code" v-model="e1TypeOfProductionBudget" return-object></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="startWeek" v-bind:label="$t('message.startWeek')" v-validate="'required'"
          :error-messages="errors.collect('startWeek')" item-text="Valor" :items="startWeekBudget"
          v-model="e4startWeekBudget"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="endWeek" v-bind:label="$t('message.endWeek')" v-validate="'required'"
          :error-messages="errors.collect('endWeek')" item-text="Valor" :items="endWeekBudget"
          v-model="e5endWeekBudget"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <label style="color: rgb(149, 149, 149);!important;font-size: 16px;
                                                    line-height: 1;
                                                    min-height: 8px;font-weight: 400;">Sucursales</label>
        <v-radio-group name="branchOffices" v-validate="'required'" :error-messages="errors.collect('branchOffices')"
          v-model="branchOfficesBudget" :mandatory="false">
          <v-radio label="Todas" value="0"></v-radio>
          <v-radio label="Sucursal Actual" value="1"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 md6>
        <v-select name="lineBusiness" v-bind:label="$t('message.lineBusiness')" v-validate="'required'"
          :error-messages="errors.collect('lineBusiness')" :items="catalogTypeOfLineBusiness" item-text="value"
          item-value="code" v-model="e1TypeOfLineBusiness" return-object></v-select>
      </v-flex>
    </v-layout>
    <!--
                                          <v-layout row wrap>
                                          </v-layout>-->


    <v-layout row wrap>
      <v-flex xs12 md10>
        <TablaProduccionLineaNegocio v-if="e6yearCommercialBudget <= 2022" :table1Budget="table1Budget" :searchTable1="searchTable1" />
        <TablaNuevaProduccionLineaNegocio
        v-if="e6yearCommercialBudget >= 2023"
        :table1Budget="table1Budget" :searchTable1="searchTable1" 
        ></TablaNuevaProduccionLineaNegocio>
      </v-flex>

      <v-flex xs12 md2>
        <WeeklyBudgetChartMemory></WeeklyBudgetChartMemory>


      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md10>
        <TablaSiniestralProduccionLineaNegocio
        v-if="e6yearCommercialBudget <= 2022"
        :table3Budget="table3Budget" 
        :searchTable="searchTable1" 
        :noRecordsMessage="$t('message.noRecords')" 
        ></TablaSiniestralProduccionLineaNegocio>
        <TablaNuevaSiniestralProduccionLineaNegocio
        v-if="e6yearCommercialBudget >= 2023"
        :table3Budget="table3Budget" 
        :searchTable="searchTable1" 
        :noRecordsMessage="$t('message.noRecords')" 
        >
        </TablaNuevaSiniestralProduccionLineaNegocio>
      </v-flex>

      <v-flex xs12 md2>
        <WeeklyBudgetChartMemoryAlert></WeeklyBudgetChartMemoryAlert>


      </v-flex>
    </v-layout>
    <v-flex class="row" style="margin-top:30px">
      <v-layout row wrap justify-space-between style="height: 60px; border-radius: 40px;">

        <h3 class="subheading text--secondary">{{ $t('message.sessionDetailsWeek') }}</h3>
        <v-btn style="height:50%; color: white;" class="hidden-xs-only" small @click="generateExcel()"
          color="green">Generar Archivo Excel</v-btn>

      </v-layout>

      <table class="tabla-detalle v-table theme--light">
        <thead>
          <tr>
            <th class="table-header text-xs-center">Semana</th>
            <th class="table-header text-xs-center">Presupuesto (#)</th>
            <th class="table-header text-xs-center">Emitido (#)</th>
            <th class="table-header text-xs-center">Emitido (%)</th>
            <th class="table-header text-xs-center">Ing. Comercial (#)</th>
            <th class="table-header text-xs-center">Ing. Comercial (%)</th>
            <th class="table-header text-xs-center">Ing. Efi Comer. (#)</th>
            <th class="table-header text-xs-center">Ing. Efi Comer. (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in table2Budget" :key="index" @click="selectRow(index)">
            <td class="text-xs-center">{{ item['Semana'] }}</td>
            <td class="text-xs-center">$ {{ item['Presupuesto'] }}</td>
            <td class="text-xs-center">$ {{ item['Produccion'] }}</td>
            <td class="text-xs-center">{{ item['ProduccionPorcentaje'] }}%</td>
            <td class="text-xs-center">$ {{ item['IngresoComercial'] }}</td>
            <td class="text-xs-center">{{ item['IngresoComercialPorcentaje'] }}%</td>
            <td class="text-xs-center">$ {{ item['IngresoEficienteComercial'] }}</td>
            <td class="text-xs-center">{{ item['IngresoEficienteComercialPorcentaje'] }}%</td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

import CatalogServices from "@/services/CatalogsServices";
import { EventBus } from "@/imports/EventBus";
import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";
//import {setTitleAndDescription} from "../../plugin"
import WeeklyBudgetChartMemory from "../../../components/MemoryChart/WeeklyBudgetChartMemory.vue"
import WeeklyBudgetChartMemoryAlert from "../../../components/MemoryChart/WeeklyBudgetChartMemoryAlert.vue"
import { downloadEXCEL } from "@/common/helpers/helpers";
import TablaProduccionLineaNegocio from "../../../components/ProduccionLineaNegocio/antigua/TablaProduccionLineaNegocio";
import TablaSiniestralProduccionLineaNegocio from "../../../components/ProduccionLineaNegocio/antigua/TablaSiniestralProduccionLineaNegocio.vue";
import TablaNuevaProduccionLineaNegocio from "../../../components/ProduccionLineaNegocio/nueva/TablaNuevaProduccionLineaNegocio.vue";
import TablaNuevaSiniestralProduccionLineaNegocio from "../../../components/ProduccionLineaNegocio/nueva/TablaNuevaSiniestralProduccionLineaNegocio.vue";
export default {
  components: {
    WeeklyBudgetChartMemory,
    WeeklyBudgetChartMemoryAlert,
    TablaProduccionLineaNegocio,
    TablaSiniestralProduccionLineaNegocio,
    TablaNuevaProduccionLineaNegocio,
    TablaNuevaSiniestralProduccionLineaNegocio
  },
  beforeDestroy() {
    EventBus.$off("WeeklyBudgetCompliance");
  },
  computed: {
    ...mapGetters(["agency", "userProfile", "agencyId", "agencyName"]),

  },
  mounted() {
    this.e3BrokerBudget = null;
    this.e6yearCommercialBudget = null;
    this.e4startWeekBudget = null;
    this.e5endWeekBudget = null;
    this.e1TypeOfProductionBudget = null;
    this.e1TypeOfLineBusiness = null;

    

    CatalogServices.getTypeOfProduction()
      .then(response => {

        this.catalogTypeOfProductionBudget = response.data.data;
      })
      .catch(res => {
        this.$root.$emit("hideLoading");
        this.$root.$emit("showSnackBar", "Error desconocido", "error");
        
      });





  },
  methods: {
    getBusinessLine(){
      
      if(this.e6yearCommercialBudget < 2023){
        CatalogServices.getTypeLineBusiness()
      .then(response => {
        if (response.data.error == 0) {
          this.catalogTypeOfLineBusiness = response.data.data;
        } else {
          this.catalogTypeOfLineBusiness = [];

        }


      })
      .catch(res => {
        this.$root.$emit("hideLoading");
        this.$root.$emit("showSnackBar", "Error desconocido", "error");
       
      });

      }else{
        CatalogServices.getLineBusinessByYear()
                    .then((response) => {
                        if (response.data.error == 0) {

                            this.catalogTypeOfLineBusiness = response.data.data;
                            this.catalogTypeOfLineBusiness.unshift({ code: "0", value: "TODOS" });
                        } else {
                            this.catalogTypeOfLineBusiness = [];
                        }
                    })
                    .catch((res) => {
                        this.$root.$emit("showSnackBar", "Error desconocido", "error");
                    });

               
      }
    
    },
    async getApsInfo(apsId) {

      let idAps = "";
      await CatalogServices.getDataApsInfo()

        .then((response) => {
          idAps = response.data.data.filter(({ codeSiaerp }) => (codeSiaerp == apsId))[0]["code"]
          

        }).catch(()=>{
          this.$root.$emit("hideLoading");
            this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
        })
      if(idAps == "" || idAps == undefined || idAps == null ){
        this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
        this.$root.$emit("hideLoading");
      }

      return idAps;
    },
    LoadGraphic() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.showGraphicBudget = false;
          this.table1Budget = [];
          this.table2Budget = [];
          this.table3Budget =[];
          this.getDataFromApiBudget();
        }
      });
    },
    nzDate: nzDate,
    refresh() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.showGraphicBudget = false;
            this.table1Budget = [];
            this.table2Budget = [];
            this.table2Budget = [];
            this.getDataFromApiBudget();
          });
        }
      });
    },
    async generateExcel() {
      this.$root.$emit(
        "showLoading",
        "Descargando Excel"
      );
      
      
      this.e3BrokerBudget= await this.getApsInfo(this.userProfile.user_id);
      // eslint-disable-next-line no-unused-vars
      let agencyId = "";
      if (this.branchOfficesBudget == "1") {
        agencyId = this.agencyName;
      } else {
        agencyId = 0;
      }
      let branchOffice = "";
      if(this.branchOfficesBudget == "0" ){
        this.branchOffice = "TODAS";
      }else{
        this.branchOffice =  this.agencyName;
      }
      let user = await this.getApsInfo(this.userProfile.user_id);
      await CommercialGraphicsServices.getDetalleSemanaExcel(user, this.e6yearCommercialBudget, this.e4startWeekBudget, this.e5endWeekBudget, this.e1TypeOfProductionBudget.value, this.branchOffice, this.e1TypeOfLineBusiness.value)
        .then((res) => {
          if (res.data.byteLength < 100) {
            this.$root.$emit("hideLoading");
            this.$root.$emit("showSnackBar", "No existen datos o Error de Datos", "warning");
            return;
          }
          let fecha = new Date();
          let fechaTexto = ((fecha.getDate()) > 9 ? '' : '0') + (fecha.getDate()) + ((fecha.getMonth() + 1) > 9 ? '' : '0') + (fecha.getMonth() + 1) + fecha.getFullYear() + "" + fecha.getHours() + "" + fecha.getMinutes()
          downloadEXCEL(
            res.data,
            "DetallePorSemana" + fechaTexto + ".xlsx"
          );
          this.$root.$emit("hideLoading");
        }).catch((error) => {
          this.$root.$emit("hideLoading");
          this.$root.$emit(
            "showSnackBar",
            "Existe un error al descargarse el Documento " + error,
            "error"
          );

        });
      this.$root.$emit("hideLoading");
    },
   async  getDataFromApiBudget() {
      this.$root.$emit(
        "showLoading",
        "Cargando cumplimiento de presupuesto"
      );
      let agencyId = "";
      let agencyName = "";
      if (this.branchOfficesBudget == "1") {
        agencyId = this.agencyId;
        agencyName = this.agencyName;
      } else {
        agencyId = "0";
        agencyName = "Todas";
      }
      this.e3BrokerBudget = await this.getApsInfo(this.userProfile.user_id);
      CommercialGraphicsServices.getBudgetGraphic(
        this.e3BrokerBudget,
        this.e6yearCommercialBudget,
        this.e4startWeekBudget,
        this.e5endWeekBudget,
        this.e1TypeOfProductionBudget.value,
        agencyName,
        this.e1TypeOfLineBusiness.value,
        agencyId,
        this.e1TypeOfLineBusiness.code,
        this.e1TypeOfProductionBudget.code,
        this.userProfile.id_aps_vt
      ).then(res => {
        this.$nextTick(() => {
          let dataResponse = res.data.data.Data;
          if (
            typeof res.data.data.Error != undefined &&
            res.data.data.Data == null

          ) {
            this.$root.$emit("hideLoading");
            this.$root.$emit("showSnackBar", res.data.data.Msg, "error");
          }
          if (typeof dataResponse != "undefined") {
            if(this.e6yearCommercialBudget <= 2022){
              this.table1Budget = res.data.data.Data.ProduccionLineaNegocio.filter(({Nombre}) => (Nombre != "Producción (52 semanas atrás)" && Nombre != "Siniestros Pagados Acumulados (52 semanas atrás)" && Nombre != "Siniestralidad Comercial (52 semanas atrás)")  );
            this.table3Budget = res.data.data.Data.ProduccionLineaNegocio.filter(({Nombre}) => (Nombre == "Producción (52 semanas atrás)" || Nombre == "Siniestros Pagados Acumulados (52 semanas atrás)" || Nombre == "Siniestralidad Comercial (52 semanas atrás)")  );
            this.table2Budget = res.data.data.Data.DetallePorSemana;

            }else{
              this.table1Budget = res.data.data.Data.ProduccionLineaNegocio.filter(({Nombre}) => (Nombre != "Producción Siniestralidad" && Nombre != "Siniestros Pagados Acumulados" && Nombre != "Siniestralidad Comercial")  );
            this.table3Budget = res.data.data.Data.ProduccionLineaNegocio.filter(({Nombre}) => (Nombre == "Producción Siniestralidad" || Nombre == "Siniestros Pagados Acumulados" || Nombre == "Siniestralidad Comercial")  );
            this.table2Budget = res.data.data.Data.DetallePorSemana;

            }
           
            this.$root.$emit("hideLoading");
          } else {
            this.$root.$emit("hideLoading");
            this.$root.$emit(
              "showSnackBar",
              "No hay datos que mostrar con los parámetros seleccionados",
              "error"
            );

            this.table1Budget = [];
            this.table2Budget = [];
            this.table3Budget = [];
          }
        }
        );
      });
    },
    setFormatNumber(num, symbol) {
      let separator = "."; // separador para los miles
      let sepDecimal = ","; // separador para los decimales
      num += "";
      var splitStr = num.split(".");
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, "$1" + separator + "$2");
      }
      return symbol + splitLeft + splitRight;
    },
    setFormatTable(table, restricts) {
      let cont = 0;
      table.forEach(element => {
        for (var property in element) {
          if (property != " " && typeof restricts[property] == "undefined") {
            let str = element[property];
            if (str != null) {
              str = str.replace(",", ".");
              str = this.setFormatNumber(str, "");
              table[cont][property] = str;
            }
          }
        }
        cont++;
      });
    },
    setCharAt(str, index, chr) {
      if (index > str.length - 1) return str;
      return str.substr(0, index) + chr + str.substr(index + 1);
    },
    formatHeadersChips(headers) {
      let cont = 0;
      headers.forEach(element => {
        for (var property in element) {
          if (property != "") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            this.headerChipsBudget[cont][property] = str;
          }
        }
        cont++;
      });
    },
    customFilter(item, queryText, itemText) {
      if (item.Descripcion != null && item.IdApsSos != null) {
        const textOne = item.Descripcion.toLowerCase();
        const textTwo = item.IdApsSos.toLowerCase();
        const searchText = queryText.toLowerCase();

        return (
          textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        );
      }
    } /* ,
    format(n) {
      return n
        .toFixed(2)
        .replace(".", ",")
        .replace(/\d{3}(?=(\d{3})*,)/g, function(s) {
          return "." + s;
        });
    } */
  },
  watch: {},
  data() {
    return {
      searchTable1: "",
      searchTable2: "",
      datasets: [],
      options: [],
      brokerBudget: [],
      showGraphicBudget: false,
      catalogTypeOfProductionBudget: [],
      annotationBudget: [],
      yAxesBudget: [{}],
      xAxesBudget: [],
      labelsBudget: [],
      dataFromGraphicBudget: [],
      headerChipsBudget: [],
      dataFromApiBudget: {},
      table1Budget: [],
      table2Budget: [],
      table3Budget:[],
      e3BrokerBudget: null,

      selectedBudget: [],
      catalogTypeOfLineBusiness: [],
      paginationBudget: {},
      yearCommercialBudget: [
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050"
      ],
      e1TypeOfProductionBudget: null,
      e1TypeOfLineBusiness: null,
      e2BranchOfficesBudget: null,
      typeProductionBudget: [],
      branchOfficesBudget: "",
      e4startWeekBudget: null,
      e5endWeekBudget: null,

      e6yearCommercialBudget: null,
      startWeekBudget: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      endWeekBudget: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      sectionDetailsLines: [],
      sessionDetailsWeek: [],
      searchValue: "",
      selected: [],
      pagination: {},
      headerSessionDetailsWeek: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.week"),
          value: "Semana",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.budgetNumber"),
          value: "Presupuesto (#)",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.issuedNumber"),
          value: "Emitido (#)",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.issuedPercent"),
          value: "Emitido (%)",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.commercialIncomeNumber"),
          value: "Ing. Comercial (#)",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.commercialIncomePercent"),
          value: "Ing. Comercial (%)",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.businessCompanyIncomeNumber"),
          value: "Ing. Efi Comer. (#)",
          width: "14%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.businessCompanyIncomePercent"),
          value: "Ing. Efi Comer. (%)",
          width: "14%"
        }
      ],
      newCatalogLineBusiness: [{
            "code": "0",
            "value": "TODOS"
        },
        {
            "code": "1",
            "value": "PERSONAS"
        },
        {
            "code": "2",
            "value": "CORPORATIVOS"
        },
        {
            "code": "3",
            "value": "CUENTAS PUBLICAS"
        },
        {
            "code": "4",
            "value": "FIANZAS"
        },
        {
            "code": "5",
            "value": "IFIS"
        },
        {
            "code": "5",
            "value": "AUTOMOTRIZ"
        }
      ],
      
    };
  }
};
</script>
<style lang="scss">
$header-table: #3AA9E0;
$principal-items: #000349 !default;
$grayColor: #dddddd !default;
$colorBlueTd: #a4cde8;
$colorRedTd: #e5a2c3;
$coloryellowTd: #fffb89;
$whiteColor: white;

.table-header {
  background-color: $header-table;
  color: white;
} 
.v-label.v-label--active.theme--light.white--text {
  color: $principal-items;
  caret-color: #fff !important;
}

.white--text {
  /* color: #fff !important; */
  color: $principal-items !important;
  caret-color: #fff !important;
}

table tr>td:first-child {
  border-left: 1px solid $grayColor;
  color: $principal-items;
  font-size: medium;
}

.table {
  border: 1px solid $grayColor;
  background-color: transparent !important;
}

.v-table tr:hover:not(.v-table__expanded__content) {
  background: transparent !important;
}

.table th+th {
  border-left: 1px solid $grayColor;
}

.table td+td {
  border-left: 1px solid $grayColor;
}

.table-header {
  background-color: $header-table;
}

.theme--light .v-table thead th {
  color: $whiteColor;
  font-size: 14px;
}

.colorbluetd {
  background-color: $colorBlueTd;
}

.colorRedtd {
  background-color: $colorRedTd;
}

.coloryellowtd {
  background-color: $coloryellowTd;
}
.textBluetd {
  color: $principal-items;
}
.textRedtd {
   color: red;
}

.tabla-detalle {
  border-collapse: collapse;
  width: 100%;
}

.tabla-detalle th,
.tabla-detalle td {
  border: 1px solid #a0a0a0;
  padding: 12px;
  font-size: 0.9rem;
}

/* Estilo para los encabezados de la tabla */
.table-header {
  background-color: #3AA9E0; /* Color directo en lugar de variable CSS */
  color: white;
  text-align: center;
  font-weight: bold;
}

.tabla-detalle tr:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.colorwhitetd {
  background-color: white;
}

@media only screen and (min-width: 1264px) {
  .container {
    max-width: 100%;
  }

}
</style>